import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, formValueSelector, reduxForm } from 'redux-form';

import { createListPhotos, removeListPhotos } from '../../actions/manageListPhotos';
import { fileuploadDir } from '../../config';
import fetch from '../../core/fetch';
import { photosShow } from '../../helpers/photosShow';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import updateStep2 from './updateStep2';
import validateStep2 from './validateStep2';
import stepFiveIllustration from '/public/SiteImages/step5.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
import cs from './ReviewPhotos.css';

class ReviewPhotos extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number,
    formPage: PropTypes.string,
    step: PropTypes.number,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    maxUploadSize: PropTypes.number,
    removeListPhotos: PropTypes.any,
    createListPhotos: PropTypes.any,
    change: PropTypes.any,
  };

  static defaultProps = {
    listPhotos: []
  };

  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      orderedPhotos: [],
      draggedIndex: null,
      dragOverIndex: null,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { listPhotos, coverPhoto } = nextProps;
    const coverId = coverPhoto || listPhotos?.[0]?.id;
    let sorted = [...(listPhotos || [])];
    const coverIndex = sorted.findIndex(item => item.id === coverId);
    if (coverIndex > 0) {
      const [item] = sorted.splice(coverIndex, 1);
      sorted.unshift(item);
    }

    if (JSON.stringify(sorted) !== JSON.stringify(prevState.prevSortedRef)) {
      return { orderedPhotos: sorted, prevSortedRef: sorted };
    }
    return null;
  }

  handleDragStart = (index) => {
    this.draggedIndex = index;
    this.setState({ draggedIndex: index });
  };

  handleDragOver = (e, index) => {
    e.preventDefault();
    if (this.state.dragOverIndex !== index) {
      this.setState({ dragOverIndex: index });
    }
  };

  handleDragEnd = () => {
    this.draggedIndex = undefined;
    this.setState({ draggedIndex: null, dragOverIndex: null });
  };

  handleDrop = (dropIndex) => {
    const { orderedPhotos } = this.state;
    const { listPhotos, change, coverPhoto } = this.props;
    const dragIndex = this.draggedIndex;

    this.setState({ draggedIndex: null, dragOverIndex: null });

    if (dragIndex === undefined || dragIndex === dropIndex) return;

    const reordered = [...orderedPhotos];
    const [removed] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, removed);

    const coverId = coverPhoto || listPhotos?.[0]?.id;

    if (dropIndex === 0) {
      const newCoverId = reordered[0]?.id;
      change('ListPlaceStep2', 'coverPhoto', newCoverId);
    } else if (coverId && dragIndex === 0) {
      const previousCover = reordered.find(item => item.id === coverId);
      if (!previousCover) {
        change('ListPlaceStep2', 'coverPhoto', reordered[0]?.id);
      }
    }

    this.setState({ orderedPhotos: reordered });
  };

  handleDelete = (item) => {
    const { removeListPhotos, change } = this.props;
    const { orderedPhotos } = this.state;

    if (orderedPhotos.length <= 1) return;

    const isCover = orderedPhotos[0]?.id === item.id;
    if (isCover && orderedPhotos.length > 1) {
      change('ListPlaceStep2', 'coverPhoto', orderedPhotos[1]?.id);
    }

    removeListPhotos(item.listId, item.name, true);
  };

  handleAddPhotosClick = () => {
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFilesSelected = async (e) => {
    const { listId, createListPhotos } = this.props;
    const files = e.target.files;
    if (!files || files.length === 0) return;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('file', file);
      try {
        const resp = await fetch('/photos', {
          method: 'POST',
          body: formData,
        });
        const result = await resp.json();
        if (result && result.files && result.files[0]) {
          createListPhotos(listId, result.files[0].filename, result.files[0].mimetype);
        }
      } catch (err) {
        console.error('Error uploading photo:', err);
      }
    }

    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step, maxUploadSize } = this.props;
    const { orderedPhotos, draggedIndex, dragOverIndex } = this.state;
    let path = photosShow(fileuploadDir);

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`¡Tarán! \n`}
            highlightText="¿Qué tal se ve tu espacio?"
            subtitle={`Sube las fotos de tu alojamiento para \n mostrar a los huéspedes cómo es cada \n espacio y atraer más reservas.`}
            iconImg={stepFiveIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={s.stepRightCard}>
              <div className={cx(s.landingMainContent, cs.contentWrapper)}>
                <div className={cs.photoGrid}>
                  {orderedPhotos.map((item, key) => {
                    const isCover = key === 0;
                    const isDragging = draggedIndex === key;
                    const isDragOver = dragOverIndex === key;

                    return (
                      <div
                        key={item.id}
                        className={cx(
                          isCover ? cs.photoItemCover : cs.photoItem,
                          isDragging && cs.isDragging,
                          isDragOver && cs.isDragOver
                        )}
                        draggable
                        onDragStart={() => this.handleDragStart(key)}
                        onDragOver={(e) => this.handleDragOver(e, key)}
                        onDragEnd={this.handleDragEnd}
                        onDrop={() => this.handleDrop(key)}
                      >
                        <div
                          className={cs.photoThumb}
                          style={{ backgroundImage: `url(${path}x_medium_${item.name})` }}
                        />
                        {isCover && (
                          <span className={cs.coverBadge}>Foto de portada</span>
                        )}
                        <button
                          type="button"
                          className={cs.deleteBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDelete(item);
                          }}
                          aria-label="Eliminar foto"
                        >
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.5 1.5L1.5 8.5M1.5 1.5L8.5 8.5" stroke="#2B7DE9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </div>
                    );
                  })}

                  <button
                    type="button"
                    className={cs.addPhotoCard}
                    onClick={this.handleAddPhotosClick}
                  >
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1" y="1" width="26" height="26" rx="5" stroke="#90CAF9" strokeWidth="1.8" />
                      <path d="M6 20l5-7 5 6 3-3.5 5 4.5" stroke="#90CAF9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <circle cx="22" cy="8" r="5" fill="#2196F3" />
                      <path d="M22 5.5v5M19.5 8h5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                    <span className={cs.addPhotoText}>Agregar más</span>
                  </button>
                </div>

                <input
                  type="file"
                  ref={this.fileInputRef}
                  multiple
                  accept="image/jpeg,image/png"
                  className={cs.hiddenInput}
                  style={{ display: 'none' }}
                  aria-hidden="true"
                  tabIndex={-1}
                  onChange={this.handleFilesSelected}
                />

                <div className={cs.infoSection}>
                  <div className={cs.infoIconWrap}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="9" cy="9" r="8" stroke="#48A7F8" strokeWidth="1.5" />
                      <path d="M9 8V13.5M9 5V6" stroke="#48A7F8" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div className={cs.infoTextWrap}>
                    <p className={cs.infoTitle}>
                      Estas son las fotos que has subido. Puedes reordenarlas, eliminarlas o agregar más si lo deseas.
                    </p>
                    <p className={cs.infoSubtitle}>
                      Puedes subir hasta 20 fotos. Formatos permitidos: JPG, PNG. Tamaño máximo: {maxUploadSize || 10} MB por foto.
                    </p>
                  </div>
                </div>
              </div>

              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                previousPagePath={"photos"}
                type={"submit"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

ReviewPhotos = reduxForm({
  form: 'ListPlaceStep2',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep2,
  onSubmit: updateStep2
})(ReviewPhotos);

const selector = formValueSelector('ListPlaceStep2');

const mapState = (state) => ({
  listPhotos: state?.location?.listPhotos,
  coverPhoto: selector(state, 'coverPhoto'),
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize,
});

const mapDispatch = {
  removeListPhotos,
  createListPhotos,
  change,
};

export default injectIntl(withStyles(s, bt, cs)(connect(mapState, mapDispatch)(ReviewPhotos)));
